import {DiscordSnowflake} from '@colonist/types'
import {AnalyticEventCategory, AnalyticEventType, ReactivationSequenceAnalytics, ReferralTypeEnum, ReactivationTypeEnum} from '../../../../shared/entity_datas/EntityDatas'
import {AjaxDataTypes} from '../../../../shared/AjaxDataTypes'
import {CA} from '../../../shared/scripts/analytics/Analytics'
import {CustomLinkUtils} from '../../../shared/scripts/ui_utils/CustomLinkUtils'
import {ReferralProgramUtils} from '../../../shared/scripts/referral/ReferralProgramUtils'

export class UIReferralProgramController {
    private readonly referrerId: DiscordSnowflake | string
    private readonly referralOrReactivationType: unknown

    constructor(referrerId: DiscordSnowflake | string, referralOrReactivationType: unknown) {
        this.referrerId = referrerId
        this.referralOrReactivationType = referralOrReactivationType
    }

    async initReferralTracking() {
        if(this.referrerId == undefined) return
        if(this.referralOrReactivationType == undefined) return

        if(this.referrerId == 'bot') {
            const reactivationType = Number(this.referralOrReactivationType) as ReactivationTypeEnum

            UIReferralProgramController.sendBotReactivationAnalytics(reactivationType)
            return
        }

        const customLink = this.referralOrReactivationType as string

        const referralType = CustomLinkUtils.extractReferralTypeFromCustomLink(customLink) as unknown as ReferralTypeEnum

        void ReferralProgramUtils.setUserReferrer(this.referrerId as DiscordSnowflake, undefined, referralType)
    }

    private static sendBotReactivationAnalytics(reactivationType: ReactivationTypeEnum) {
        const botShareActivityLinkAnalytics = UIReferralProgramController.getBotShareActivityLinkAnalytics(reactivationType)
        if(botShareActivityLinkAnalytics != undefined) {
            const eventDataBotShareActivityLink: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ReactivationAnalytics,
                category: AnalyticEventCategory.BotShareActivityLink,
                floatValue: botShareActivityLinkAnalytics,
            }
            void CA.sendAnalyticEvent(eventDataBotShareActivityLink)
        }
    }

    private static getBotShareActivityLinkAnalytics(reactivationType: ReactivationTypeEnum): ReactivationSequenceAnalytics | undefined {
        switch(reactivationType) {
            case ReactivationTypeEnum.Reactivation24HoursAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation24HoursAfterLastActivityLaunch
            case ReactivationTypeEnum.Reactivation1WeekAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation1WeekAfterLastActivityLaunch
            case ReactivationTypeEnum.Reactivation1MonthAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation1MonthAfterLastActivityLaunch
            case ReactivationTypeEnum.Reactivation3MonthsAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation3MonthsAfterLastActivityLaunch
            case ReactivationTypeEnum.Reactivation6MonthsAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation6MonthsAfterLastActivityLaunch
            case ReactivationTypeEnum.Reactivation1YearAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation1YearAfterLastActivityLaunch
            case ReactivationTypeEnum.Reactivation2YearsAfterLastActivityLaunch:
                return ReactivationSequenceAnalytics.Reactivation2YearsAfterLastActivityLaunch
            default:
                return undefined
        }
    }
}
